/* eslint-disable no-undef */
// set dynamic loaded chunk public path on the fly
__webpack_public_path__ =
  process.env.NODE_ENV === 'development'
    ? '/headhunter/'
    : (window?.MOKA_RETRY?.getCdnPath() || '') + '/headhunter/';
